$(document).ready(function () {

    var projectData = (function () {

        var $window = $(window);

        var init = function () {

            // for test purposes

            // console.log('project init');
            //
            // let data = {};
            //
            // $.ajax({
            //     method: "POST",
            //     url: '/kbw/user/test',
            //     data: data,
            //     dataType: "json"
            //
            // }).done(function (returnData) {
            //     //console.log(returnData['output']);
            //     // if (returnData['success']) {
            //     //     console.log(returnData['numDocs']);
            //     // }
            //
            //     console.log(returnData['output']);
            //
            // }).fail(function (jqXHR, textStatus) {
            //     console.log(textStatus);
            // });


            initDatepicker();
            addEventListeners();
            return;
        };

        var addEventListeners = function () {

            $('.js-new-multirow').on('click', handleNewMultirow);
            $('.js-multifield').on('click', '.js-remove-multirow', handleRemoveMultirow);
            $('.js-percent-check').on('change', handleChangePercent);
            $('.js-percent-part').on('keyup', handleChangePercent);

        }

        var initDatepicker = function() {
            $('.datepicker').datepicker({
                dateFormat: "dd.mm.yy",
                showOn: "button",
                buttonImage: "files/framework/img/calendar.gif",
                buttonImageOnly: true,
                buttonText: "Select date",
                changeMonth: true,
                changeYear: true,
                monthNames: ['Januar','Februar','März','April','Mai','Juni',
                    'Juli','August','September','Oktober','November','Dezember'],
                monthNamesShort: ['Jan','Feb','Mär','Apr','Mai','Jun',
                    'Jul','Aug','Sep','Okt','Nov','Dez'],
                dayNames: ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
                dayNamesShort: ['So','Mo','Di','Mi','Do','Fr','Sa'],
                dayNamesMin: ['So','Mo','Di','Mi','Do','Fr','Sa']
            });
        }

        var handleNewMultirow = function(event) {
            event.preventDefault();

            let $target = $(event.currentTarget);

            let fieldName = $target.data('multirow');
            let rowCounter = $target.data('multirow-max');

            let data = {
                fieldName: fieldName,
                rowCounter: rowCounter
            }

            console.log(fieldName + rowCounter);

            let $container = $('#multirow_' + fieldName);
            // let url = '/kbw/multirow/' + fieldName;
            let url = '/kbw/multirow/add';

            ajaxPost(url, data, $container, $target, addMultirow);
        }

        var handleRemoveMultirow = function(event) {
            event.preventDefault();

            let $target = $(event.currentTarget);
            let rowId = $target.data('multirow');

            $('#multirow_' + rowId).remove();
        }

        var ajaxPost = function(url, data, $container, $target, successCallback) {
            $.ajax({
                method: "POST",
                url: url,
                data: data,
                dataType: "json"

            }).done(function (returnData) {
                //console.log(returnData['output']);
                // if (returnData['success']) {
                //     console.log(returnData['numDocs']);
                // }

                if (returnData['output'] !== 'undefined') {
                    successCallback($container, $target, returnData);
                }

            }).fail(function (jqXHR, textStatus) {
                console.log(textStatus);
            });
        }

        var addMultirow = function($container, $target, data) {
            $container.append(data['output']);
            $target.data('multirow-max', data['rowCounter']);

            console.log($container);
            console.log(data['rowCounter']);
            // alert('success');
        }

        var handleChangePercent = function(event) {
            //event.preventDefault();

            let $target = $(event.currentTarget);
            let $element = $target.parents('.project-form__field');

            let percentSum = 0;

            $element.find('.js-percent-check:checked').each(function() {
                let id = $(this).attr('id');

                percentSum += getPercentValue($('#' + id + '_percent').val());
            });

            $element.find('.js-percent-sum').html(percentSum);
        }

        var getPercentValue = function(input) {
            let numValue = parseInt(input, 10);

            if (isNaN(numValue)) {
                numValue = 0;
            }

            return numValue;
        }

        // var closeAbandonendLayers = function() {
        //     if ($('body').hasClass('targetnav-open') && !$(this).hasClass('js-toggle-targetnav')) {
        //         if ($(this).parents('#targetnavlayer').length === 0) {
        //             $('.js-toggle-targetnav').trigger('click');
        //         }
        //     }
        //     if ($('body').hasClass('languages-open') && !$(this).hasClass('js-toggle-languages')) {
        //         if ($(this).parents('#languagelayer').length === 0) {
        //             $('.js-toggle-languages').trigger('click');
        //         }
        //     }
        //     if ($('body').hasClass('searchlayer-open')) {
        //         if ($(this).parents('#searchlayer').length === 0) {
        //             if ($('.js-toggle-search').hasClass('open')) {
        //                 $('.js-toggle-search').trigger('click');
        //             }
        //             if ($('.js-toggle-searchlink').hasClass('open')) {
        //                 $('.js-toggle-searchlink').trigger('click');
        //             }
        //         }
        //     }
        // }
        //
        // var handleToggleTargetNav = function() {
        //     if ($('body.homepage').length > 0) {
        //         // homepage
        //         if ($(this).hasClass('open')) {
        //             $('#targetnavlayer').slideToggle(function() {
        //                 $('#targetnavlayer').detach().insertAfter('.mod_targetnav__button-container');
        //             });
        //         } else {
        //             $('#targetnavlayer').detach().appendTo('.header').slideToggle();
        //         }
        //         // move target navigation
        //     } else {
        //         // contentpage
        //         $('#targetnavlayer').slideToggle(function() {
        //             if ($('body').hasClass('targetnav-open')) {
        //                 //$('.mod_mainnav__box-slide').css('overflowY', 'auto');
        //                 // $(".mod_mainnav__box-slide").scrollTop($(".mod_mainnav__box-slide").prop("scrollHeight"));
        //                 $(".mod_mainnav__box").scrollTop($(".mod_mainnav__box").prop("scrollHeight"));
        //
        //                 // $("#mainnavlayer").scrollTop($("#mainnavlayer").prop("scrollHeight"));
        //                 // $('#mainnavlayer').scrollTop(100);
        //                 // console.log('open');
        //                 // console.log($(".mod_mainnav__box").height());
        //                 // console.log($(".mod_mainnav__box-slide").height());
        //             }
        //
        //         });
        //     }
        //     $('body').toggleClass('targetnav-open');
        //     $('.header').toggleClass('with-targetnav');
        //     $(this).toggleClass('open');
        //     $(this).parent().toggleClass('open');
        // }
        //
        // var handleToggleLanguages = function() {
        //     $('body').toggleClass('languages-open');
        //     $(this).toggleClass('open');
        //     $('#languagelayer').slideToggle();
        // }
        //
        // var handleToggleSearch = function() {
        //     if (searchLayerMoving) {
        //         return;
        //     }
        //
        //     if ($(this).parent().children('#searchlayer').length > 0) {
        //         searchLayerMoving = true;
        //         $('#searchlayer').slideToggle(function() {
        //             $('#searchlayer').detach().appendTo('.topheader__container');
        //             searchLayerMoving = false;
        //         });
        //
        //     } else {
        //         $('#searchlayer').detach().appendTo('.mod_funcnav .level_1 > .search');
        //         searchLayerMoving = true;
        //         $('#searchlayer').slideToggle(function () {
        //             searchLayerMoving = false;
        //         });
        //     }
        //     $('body').toggleClass('searchlayer-open');
        //     $(this).toggleClass('open');
        // }
        //
        // var handleToggleSearchLink = function() {
        //     if (searchLayerMoving) {
        //         return;
        //     }
        //
        //     if ($(this).parent().children('#searchlayer').length > 0) {
        //         searchLayerMoving = true;
        //         $('#searchlayer').slideToggle(function() {
        //             $('#searchlayer').detach().appendTo('.topheader__container');
        //             searchLayerMoving = false;
        //         });
        //
        //     } else {
        //         $('#searchlayer').detach().appendTo('.mod_searchlink');
        //         searchLayerMoving = true;
        //         $('#searchlayer').slideToggle(function() {
        //             searchLayerMoving = false;
        //         });
        //     }
        //     $('body').toggleClass('searchlayer-open');
        //     $(this).toggleClass('open');
        // }
        //
        // var handleToggleMainNav = function() {
        //     // if ($('.header').children('#mainnavlayer').length > 0) {
        //     //     $('#mainnavlayer').toggle(0, function() {
        //     //         $('#mainnavlayer').detach().appendTo('.mod_mainnav');
        //     //     });
        //     //
        //     // } else {
        //     $('.mod_targetnav').detach().appendTo('.mod_mainnav__targetgroup-nav');
        //
        //         $('#mainnavlayer').detach().appendTo('.header');
        //         $('#mainnavlayer').toggle(0);
        //     // }
        //     $('.header').toggleClass('navi-open');
        //     $('body').toggleClass('mainnav-open');
        // }
        //
        // var handleMainNavLevel1 = function(event) {
        //     if ($('.mod_mainnav #mainnavlayer').length > 0) {
        //         // alert('found');
        //         return;
        //     }
        //
        //     event.preventDefault();
        //
        //     var layerToShow = $(this).parent().children('.level_2');
        //
        //     $('.mod_mainnav__container').find('.level_2').hide();
        //
        //     layerToShow.show();
        //
        //     var layerHeight = layerToShow.height();
        //
        //     // $('.mod_mainnav__box-slide').height(layerHeight);
        //     // $('.mod_mainnav__box').height(layerHeight);
        //     $('.mod_mainnav__box-slide').css('left', '-100%');
        // }
        //
        // var handleMainNavLevel2Back = function(event) {
        //     event.preventDefault();
        //
        //     $('.mod_mainnav__box-slide').css('left', '0');
        //     // $('.mod_mainnav__box-slide').height('auto');
        //     // $('.mod_mainnav__box').height('auto');
        // }
        //
        // var handleMainNavClose = function() {
        //     if ($('.header').children('#mainnavlayer').length > 0) {
        //         $('#mainnavlayer').toggle(0, function() {
        //             $('#mainnavlayer').detach().appendTo('.mod_mainnav');
        //             $('.header').removeClass('navi-open');
        //             $('body').removeClass('mainnav-open');
        //             $('.mod_targetnav').detach().appendTo('.topheader__container');
        //
        //         });
        //
        //     }
        //
        // }
        //


        return {
            init: init
        }

    })();

    projectData.init();

});



